import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: Theme) => {
  const transitionTime = {
    easing: theme.transitions.easing.sharp,
    duration: 250,
    delay: 100,
  }

  return {
    root: {
      paddingLeft: 25,
      paddingRight: 25,
      paddingTop: 25,
      paddingBottom: 25,
      transition: theme.transitions.create(['all'], transitionTime),
      width: 1300,
      margin: '0px auto',
    },
    center: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      flexWrap: 'wrap',
    },
    paddingZero: {
      paddingTop: 0,
    },
  }
})

export default useStyles
